// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__A-lLr","fullWidthRoot":"Container_fullWidthRoot__TEcMx"};